import MaterialTable from "material-table";
import React, { useCallback, useEffect, useState } from "react";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { CurrentUserHasRole } from "../../api/auth";
import { roles } from "../../config";
import { tableIcons } from "../../helpers/tableIcons";
import local from "../../localization/strings";
import { getDepartments } from "../../api/department";

const SaveAsWidgetDropdown = ({ onSave }) => {
	const [data, setData] = useState([]);

	const loadData = useCallback(async () => {
		var result = await getDepartments();
		setData(result);
	}, []);

	useEffect(() => {
		if (CurrentUserHasRole(roles.Distributor)) {
			loadData();
		}
	}, [loadData]);

	const columns = [
		{ field: "name", defaultSort: "asc", cellStyle: { width: 500, maxWidth: 500 }, headerStyle: { width: 500, maxWidth: 500 } }, //
	];

	const saveDashboardAs = (rowData) => {
		onSave(rowData.id);
	};

	return (
		<UncontrolledDropdown direction="up" className="allow-overflow">
			<DropdownToggle caret transform="shrink-3" color="falcon-warning">
				<span className="d-none d-md-inline-block ml-2">{local.TF_SaveAsDefault}</span>
			</DropdownToggle>
			<DropdownMenu className="menu-border-blue p-2">
				<div>
					<div>{local.TF_Areas}:</div>
					<MaterialTable
						onRowClick={(_, rowData) => {
							saveDashboardAs(rowData);
						}}
						columns={columns}
						data={[{ id: -1, name: ` ${local.TF_Site}` }, ...data]}
						title=""
						icons={tableIcons}
						options={{ toolbar: false, search: false, header: false, paging: false, showEmptyDataSourceMessage: false }}
					/>
				</div>
			</DropdownMenu>
		</UncontrolledDropdown>
	);
};

export default SaveAsWidgetDropdown;
